<div class="modal-header">
    <h5 class="modal-title">Chi Tiết Mã Vạch</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <img [src]="retrievedImage">
    <p><strong>ISBN:</strong> {{ barCode?.isbn }}</p>
    <p><strong>Chiều Rộng:</strong> {{ barCode?.width }} cm</p>
    <p><strong>Chiều Cao:</strong> {{ barCode?.height }} cm</p>
    <p><strong>Loại:</strong> {{ barCode?.type }} cm</p>
</div>

<div class="modal-footer">
<button type="button" class="btn btn-outline-success" (click)="closeModal()">
            <i class="fas fa-paper-plane"></i> Đóng
        </button>
</div>

